module.exports = __webpack_public_path__ + "0c780283630d4a5f47c4a47f7e19267d.png";